import { LoadInfo, SettingsNode, IGameConfiguration } from "../multigame/api";
import { AudioManager } from "../multigame/AudioManager";
import type { ISystemContext } from "../multigame/Context/SystemContext";
import { Orientation } from "../multigame/FitScreen";
import { IGameFactory, CreateGameFactory } from "../multigame/GameFactoy";
import { IJackpotDisplay } from "../multigame/IJackpotDisplay";
import { IJackpotDisplayFactory } from "../multigame/IJackpotDisplayFactory";
import { IMultigame } from "../multigame/IMultigame";
import { Button } from "../multigame/IO";
import { JackpotDisplayFactory } from "../multigame/JackpotDisplayFactory";
import { JackpotDisplayParams } from "../multigame/JackpotDisplayParams";
import { MultigameParams } from "../multigame/MultigameParams";
import { MultigamePixiAPP } from "../multigame/MultigamePixiAPP";
import { Size } from "../multigame/MyHelpers";
import { Resource } from "../multigame/ResourceManager/Resource";
import { ResourceIdentifier } from "../multigame/ResourceManager/ResourceIdentifier";
import { LoadingStage, IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../multigame/ResourceManager/ResourceManager";
import { ScreenProtocol } from "../multigame/ScreenProtocol";
import { service } from "../multigame/services";
import { Settings, Screen3SettingDisplay } from "../multigame/Settings";
import { SlotGame } from "../multigame/slot/SlotGame";
import { SlotGameInitData } from "../multigame/SlotGameInitData";
import { SpeedManager } from "../multigame/SpeedManager";
import { ZIndex } from "../multigame/ZIndex";
import { SimpleSlotGameConfiguration } from "./singlegame_api";
import { singleApi } from "./SinglegameStartup";

export class Singlegame_PIXIAPP2 implements IMultigame
{
    protected jackpotDisplay: IJackpotDisplay = null;
    protected JackpotDisplayFactory: IJackpotDisplayFactory = new JackpotDisplayFactory();

    protected resid: ResourceIdentifier = new ResourceIdentifier("Screen1_2", "Multigame");

    protected viewSize: Size = new Size(Settings.ScreenWidth, Settings.ScreenHeight);
    
    public constructor(
        private systemContext: ISystemContext,
        private audioManager: AudioManager,
        private speedManager: SpeedManager
    )
    {
        this.systemContext = systemContext.CreateSubContext("Multigame");



    if (Settings.screen3Display == Screen3SettingDisplay.JackpotDisplay) {
        let params: JackpotDisplayParams = {
            systemContext: this.systemContext,
            resid: this.resid,
            viewSize: this.viewSize,
            screenProtocol: new ScreenProtocol("1_2"),
        };
        
        this.jackpotDisplay = this.JackpotDisplayFactory.CreateNewJackpotDisplay(params);
        params = null;
        globalThis.jackpotDisplayGlobal = this.jackpotDisplay;
        // this.jackpotDisplay.View().style.zIndex = ZIndex.JPType.toString();
        // this.jackpotDisplay.View().style.top = Settings.Enable2plus1 == true ? (Settings.ScreenHeight* -1) + "px" : -(Settings.ScreenHeight * (Settings.Screens - 1))+ "px";
    }

    }
    GameExit(silent?: boolean): void {
        throw new Error("Method not implemented.");
    }
    View(): HTMLElement {
        return null;
    }
    ViewReady(): void {
    }
    Update(): void {
    }
    OnButtonChanged(button: Button, pressed: boolean): void {
    }
    BackgroundView(): HTMLElement {
        return null;
    }
    SetLoadInfo(loadInfo: LoadInfo, settings: SettingsNode, games: IGameConfiguration[]) {
    }
    LoadProgress(percent: number): void {
    }
    LoadFinishedSuccess(): Promise<void> {
        return null;
    }
    LoadFailed(loadingStage: LoadingStage, resources: Resource[]): Promise<void> {
        return null;
    }
    public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
    }
    
    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
        
        if (loadingStage == LoadingStage.Finished) await this.ResourcesLoadedFinished(resourceManager);

    }

    protected async ResourcesLoadedFinished(resourceManager: IReadOnlyResourceManager): Promise<void> {
        
    }
    protected async ProtocolSetup(): Promise<void> {
	    await singleApi.registerOperation("JackpotValuesUpdate",     this.resid.ID(), (data) => {
			//if (this.screenProtocol != null) this.screenProtocol.Send(new JackpotValuesUpdate2(data), this.screenScope);
			const values = Object.values(data.JackpotValues);
			// this.OnJackpotValues(values);
		});
    }

    protected async selectRandomGame(): Promise<void> {

    }
    
    public async OnResize(w: number, h: number, orientation: Orientation): Promise<void> {
    }
}